import React from "react";
import {
  Scissors,
  Trees,
  Sprout,
  Wrench,
  Flower2,
  Leaf,
  Trash2,
  Hammer,
} from "lucide-react";

const SERVICES = [
  {
    icon: Scissors,
    title: "Lawn Mowing & Care",
    desc: "Regular cuts, edging, scarification and feeding for a healthy, picture-perfect lawn.",
    span: "lg:col-span-5",
    accent: "bg-brand-moss text-white",
  },
  {
    icon: Trees,
    title: "Hedge Trimming",
    desc: "Crisp, even hedges shaped with care — from box balls to long boundary hedges.",
    span: "lg:col-span-4",
    accent: "bg-brand-terracotta text-white",
  },
  {
    icon: Hammer,
    title: "Landscaping & Design",
    desc: "Patios, raised beds, fencing, paths and full garden makeovers tailored to you.",
    span: "lg:col-span-3 row-span-2",
    accent: "bg-brand-moss-deep text-white",
    big: true,
  },
  {
    icon: Sprout,
    title: "Planting & Borders",
    desc: "Seasonal planting, border refreshes and cottage-style colour all year round.",
    span: "lg:col-span-3",
    accent: "bg-brand-leaf text-white",
  },
  {
    icon: Flower2,
    title: "Weeding & Mulching",
    desc: "Deep weeding plus bark or compost mulch to keep beds tidy and moisture-locked.",
    span: "lg:col-span-3",
    accent: "bg-brand-terracotta text-white",
  },
  {
    icon: Wrench,
    title: "Garden Maintenance",
    desc: "Regular visits keeping every corner in shape — weekly, fortnightly or monthly.",
    span: "lg:col-span-3",
    accent: "bg-brand-moss text-white",
  },
  {
    icon: Trash2,
    title: "Garden Clearance",
    desc: "Overgrown jungle? We tame, tidy and take it all away with proper green-waste disposal.",
    span: "lg:col-span-6",
    accent: "bg-brand-moss-deep text-white",
  },
  {
    icon: Leaf,
    title: "Seasonal Tidy-Ups",
    desc: "Spring prep, autumn leaf clears and winter readiness so your garden is ready for every season.",
    span: "lg:col-span-6",
    accent: "bg-brand-leaf text-white",
  },
];

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 sm:py-32 px-6 sm:px-10 lg:px-14"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <div className="max-w-xl">
            <span className="text-xs uppercase tracking-[0.22em] font-semibold text-brand-terracotta">
              What we do
            </span>
            <h2
              data-testid="services-heading"
              className="mt-3 font-display font-bold text-brand-moss-deep text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight"
            >
              Real gardening,<br />done with real care.
            </h2>
          </div>
          <p className="max-w-md text-base sm:text-lg text-brand-charcoal/80 leading-relaxed">
            Whether it's a one-off rescue or a regular tidy, every visit comes with the same
            promise — turn up on time, do it properly, leave the place better than we found it.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-6 lg:grid-cols-12 gap-5 lg:gap-6">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <article
                key={s.title}
                data-testid={`service-card-${i}`}
                className={`group bg-white border border-brand-line rounded-3xl p-7 sm:p-8 hover:shadow-[0_18px_40px_rgba(74,93,35,0.10)] hover:-translate-y-1 transition-all duration-300 flex flex-col ${s.span} ${s.big ? "min-h-[420px]" : ""}`}
              >
                <div className={`w-12 h-12 rounded-2xl ${s.accent} grid place-items-center mb-6 shadow-sm group-hover:rotate-[-6deg] transition-transform`}>
                  <Icon className="w-5 h-5" strokeWidth={2.2} />
                </div>
                <h3 className="font-display font-semibold text-xl sm:text-2xl text-brand-moss-deep tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-brand-charcoal/85 leading-relaxed text-[15px]">
                  {s.desc}
                </p>
                {s.big && (
                  <div className="mt-auto pt-8">
                    <a
                      href="#contact"
                      className="inline-flex items-center gap-2 text-sm font-semibold text-brand-terracotta hover:text-brand-terracotta-dark"
                    >
                      Plan a project →
                    </a>
                  </div>
                )}
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
